import(/* webpackMode: "eager" */ "/app/app/videos/page.tsx");
